import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'antd'
import QuillRenderer from '../text-editor/QuillRenderer'
import { ALERT_TYPES } from '../../../utils/patternSeverity.helper'

const PatternFeedbackWidget = ({ name, feedback, grade, type }) => {
    const pointsString = grade ? `${grade > 0 ? '+' : ''}${grade} points` : ''

    const description = (
        <>
            <QuillRenderer htmlContent={feedback} />
            {grade ? (
                <div style={{ marginTop: '8px' }}>
                    <code>{pointsString}</code>
                </div>
            ) : null}
        </>
    )

    return <Alert message={name} description={description} type={type} showIcon style={{ margin: '8px 0' }} />
}

PatternFeedbackWidget.propTypes = {
    name: PropTypes.string,
    feedback: PropTypes.string.isRequired,
    grade: PropTypes.number,
    type: PropTypes.oneOf(Object.values(ALERT_TYPES)).isRequired,
}

export default PatternFeedbackWidget

